import { ITerminalErrorEntry } from "../terminalError";

export interface ITerminalActionResponse {
	status: "success" | "fail" | string;
	message?: {
		messageHeader?: Record<string, unknown>;
		messagePayload?: unknown;
	};
	error?: string;
	errors?: ITerminalErrorEntry[];
}

export const TERMINAL_ENDPOINTS = {
	LOGON: "/terminal/logon",
	UPDATE: "/terminal/update",
	RESET_SEQUENCE: "/terminal/resetsequence",
	RESET: "/terminal/reset",
	SETTLEMENT_CREDIT_CARD: "/terminal/settlement/creditcard",
	SETTLEMENT_NETS: "/terminal/settlement/nets",
} as const;

export type TerminalEndpoint = (typeof TERMINAL_ENDPOINTS)[keyof typeof TERMINAL_ENDPOINTS];
